import React from "react";
import Fontstyling from "../comman";

const NoDataMassage = (props) => {
  return (
    <div
      className="d-flex justify-content-center border align-items-center"
      style={{ height: "60px" }}
    >
      <div
        style={{
          fontSize: "0.875rem",
          fontFamily: "Roboto, Helvetica, Arial, sans-serif",
          fontWeight: "400",
          letterSpacing: "0.01071em",
          verticalAlign: "inherit",
        }}
      >
        {props.massage}
      </div>
    </div>
  );
};

export default NoDataMassage;
